export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7805.2652cdf3.jpg";